namespace JupitersChoice {
    export class InitSpinnerCmd {
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;

        execute(): void {
            const spinner = this._componentManager.get('Spinner');
            const spinnerMask: Sapphire.Graphic = this._componentManager.get('SpinnerMask');
            const wheelConfig = this._config.get('wheel');
            const baseGame: Sapphire.BaseGame = this._componentManager.get('BaseGame');

            //(<Sapphire.AnimatedSprite>this._componentManager.get('LightningSeparator')).play();

            // wheelConfig.multipliers.forEach((multiplier, idx) => {
            //     spinner.addText('x' + multiplier, {
            //         x: spinner.customProps.multiplierPositions[idx][0],
            //         y: spinner.customProps.multiplierPositions[idx][1]
            //     });
            // });

            this._componentManager.get('SpinnerOuterHighlight').mask =this._componentManager.get('SpinnerFrameMask');
            for(var i=1; i<=8; ++i){
                this._componentManager.get('SpinnerOuterValueLightning'+i).mask = this._componentManager.get('SpinnerFrameMask');
            }

            // Add spinner layer behind the reel frame
            baseGame.addChildAt(
                this._layerManager.getLayerById('Spinner'),
                baseGame.getChildIndex(this._componentManager.get('ReelFrame'))
            );

            spinner.mask = spinnerMask;

            spinner.addTween('drop', () => {

                this._soundManager.play('wheel_slide');

                new TimelineMax()
                    .to(spinner, 1.2, {y: 100, ease: Quart.easeIn})
                    .to(spinner, .1, {y: 80, ease: Quart.easeOut})
                    .to(spinner, .05, {y: 100, ease: Quart.easeIn});
            });
        }
    }
}